
import { supabase } from '@/integrations/supabase/client';

interface SitemapUrl {
  loc: string;
  lastmod: string;
  changefreq: 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';
  priority: number;
}

export const generateSitemap = async (): Promise<string> => {
  const baseUrl = 'https://itmgmtsol.com';
  const urls: SitemapUrl[] = [];

  // Static pages
  const staticPages = [
    { url: '', priority: 1.0, changefreq: 'weekly' as const },
    { url: '/services/managed-it', priority: 0.9, changefreq: 'monthly' as const },
    { url: '/services/cybersecurity', priority: 0.9, changefreq: 'monthly' as const },
    { url: '/services/cloud-solutions', priority: 0.9, changefreq: 'monthly' as const },
    { url: '/services/network-infrastructure', priority: 0.9, changefreq: 'monthly' as const },
    { url: '/services/project-consulting', priority: 0.8, changefreq: 'monthly' as const },
    { url: '/services/specialty-services', priority: 0.8, changefreq: 'monthly' as const },
    { url: '/services/residential', priority: 0.8, changefreq: 'monthly' as const },
    { url: '/blog', priority: 0.8, changefreq: 'daily' as const },
    { url: '/contact', priority: 0.7, changefreq: 'monthly' as const },
    { url: '/book', priority: 0.8, changefreq: 'monthly' as const },
    { url: '/privacy', priority: 0.3, changefreq: 'yearly' as const },
    { url: '/terms', priority: 0.3, changefreq: 'yearly' as const }
  ];

  staticPages.forEach(page => {
    urls.push({
      loc: `${baseUrl}${page.url}`,
      lastmod: new Date().toISOString().split('T')[0],
      changefreq: page.changefreq,
      priority: page.priority
    });
  });

  // Dynamic location pages
  try {
    const { data: locations } = await supabase
      .from('locations')
      .select('slug, updated_at, priority')
      .eq('is_published', true)
      .eq('is_active', true);

    if (locations) {
      locations.forEach(location => {
        urls.push({
          loc: `${baseUrl}/${location.slug}`,
          lastmod: new Date(location.updated_at).toISOString().split('T')[0],
          changefreq: 'monthly',
          priority: location.priority || 0.7
        });
      });
    }
  } catch (error) {
    console.error('Error fetching locations for sitemap:', error);
  }

  // Generate XML
  const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${urls.map(url => `  <url>
    <loc>${url.loc}</loc>
    <lastmod>${url.lastmod}</lastmod>
    <changefreq>${url.changefreq}</changefreq>
    <priority>${url.priority}</priority>
  </url>`).join('\n')}
</urlset>`;

  return sitemap;
};

export const downloadSitemap = async () => {
  const sitemap = await generateSitemap();
  const blob = new Blob([sitemap], { type: 'application/xml' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'sitemap.xml';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
